import { render, staticRenderFns } from "./ClienteLista.vue?vue&type=template&id=d16005e2&scoped=true"
import script from "./ClienteLista.vue?vue&type=script&lang=js"
export * from "./ClienteLista.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d16005e2",
  null
  
)

export default component.exports